import Manage from "./Manage";

export default Manage;
